module.exports = __webpack_public_path__ + "static/media/Group.c054c5cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Group.png
// module id = 435
// module chunks = 0